import { expressEventListener, expressQuerySelectorAll, htmlToElement } from "../../common/html";
import { compositeDisposable } from "../../utils/disposable";
import { getHtmlRequest } from "../../utils/fetch";
import { INavigationDesktopDeps } from "./navigation-desktop-first-level";

export function CreateNavigationDesktopSecondLevel(container: HTMLElement, deps: INavigationDesktopDeps) {
	const HIDE_CLASS = "u-hide";
	const LOADING_CLASS = "skeleton-loading";
	const loading = {}; // save the firstlevelindex with there loading sate
	const { activatedElement, getActiveIndex } = deps;
	let menuItems = expressQuerySelectorAll<HTMLElement>(container, ".technical-navigation-item");

	const addEventListenersToMenuItem = (x: HTMLElement) => {
		return compositeDisposable([
			expressEventListener(x, "click", () => {
				activatedElement(x);
			}),
			expressEventListener(x, "mouseover", () => {
				activatedElement(x);
			}),
		]);
	};

	const disposible = menuItems.map((x) => addEventListenersToMenuItem(x));
	const open = async (firstLevelIndex: number) => {
		const firstLevelIndexString = firstLevelIndex.toString();
		const secondMenuAlreadyLoaded = menuItems.some((x) => x.dataset.parentIndex === firstLevelIndexString);
		if (!secondMenuAlreadyLoaded && !loading[firstLevelIndex]) {
			loading[firstLevelIndex] = true;
			container.classList.toggle(HIDE_CLASS, false);
			container.classList.toggle(LOADING_CLASS, true);
			const request = await getHtmlRequest(`apicore/headerapi/desktopmenu?indexLevel1=${firstLevelIndexString}`, {
				headers: new Headers({ pragma: "no-cache", "cache-control": "no-cache" }),
			});

			const requestNode = htmlToElement(request) as HTMLElement;
			const secondLevelItems = expressQuerySelectorAll<HTMLElement>(
				requestNode,
				`.technical-navigation-item[data-parent-index='${firstLevelIndex}'][data-has-third-level]`,
			);

			// add items to DOM && javascript variable
			const isStllActiveIndex = getActiveIndex() === firstLevelIndex;
			secondLevelItems.forEach((x) => {
				disposible.push(addEventListenersToMenuItem(x));
				x.classList.toggle(HIDE_CLASS, !isStllActiveIndex);
				container.appendChild(x);
			});
			menuItems = [...menuItems, ...secondLevelItems];
			loading[firstLevelIndex] = false;

			if (!isStllActiveIndex) return; // don't update item not active anymore
		}

		menuItems.forEach((x) => x.classList.toggle(HIDE_CLASS, x.dataset.parentIndex !== firstLevelIndexString));
		container.classList.toggle(LOADING_CLASS, !!loading[firstLevelIndex]);
		container.classList.toggle(HIDE_CLASS, false);
	};

	const close = () => {
		container.classList.toggle(HIDE_CLASS, true);
	};

	return {
		dispose: () => disposible.forEach((x) => x.dispose()),
		open,
		close,
	};
}
